import React, { Fragment, useEffect, useReducer, useState } from "react";
import AssetCreation from "./AssetCreation";
import EmissionMetric from "../Target/EmissionMetric";
import { toastMessage } from "../../helper";
import {
  emissionScopeService,
  targetUOMService,
} from "../../services/emissionService";
import {
  fetchBusinessUnit,
  fetchBusinessUnits,
} from "../../services/orgService";
import { createTargetService } from "../../services/targetService";
import { useLocation, useNavigate } from "react-router-dom";
import { deepClone } from "@mui/x-data-grid/utils/utils";
import assetReducer, { defaultAssetState } from "../../reducers/assetReducer";
import { ASSET_REDUCER, STEPS } from "../../constants/enums";
import { useTranslation } from "react-i18next";
import { getAssetService } from "../../services/assetService";

const TargetHome = () => {
  const [step, setStep] = useState(STEPS.BASIC_INFO);
  const [bunitList, setBunitsList] = useState([]);
  const navigate = useNavigate();
  const [isSubmit, setIsSubmit] = useState(false);
  const [activeSection, setActiveSection] = useState<string>("basicInfo");
  const [targetState, dispatch] = useReducer(assetReducer, defaultAssetState);
  const { t, i18n } = useTranslation();
  const { state } = useLocation();

  // useEffect(() => {
  //   if (isSubmit) {
  //     let reqObj = {
  //       localCode: targetState.localCode,
  //       ownerShip: targetState.ownerShip,
  //       type: targetState.type,
  //       description: targetState.description,
  //       location: targetState.location,
  //       departmentName: targetState.departmentName,
  //       categoryName: targetState.categoryName,
  //       emissionFactor: null,
  //       emissionSource: null,
  //       emissionSubSource: null,
  //       engine: null,
  //       fuel: null,
  //       country: null,
  //       uom: null,
  //       uomName: "",
  //       noOfUnits: 1,
  //       value: null,
  //       notes: "",

  //       emissionSourceUrl: "",
  //       currency: "",
  //     };
  //     console.log("reqObj", reqObj);
  //     // createTargetService(reqObj)
  //     //   .then((res: any) => {
  //     //     toastMessage("Asset Created Successfully", "success");
  //     //     navigate("/assets");
  //     //   })
  //     //   .catch((err) => {
  //     //     console.log(err);
  //     //   });
  //   }
  // }, [isSubmit]);

  return (
    <div className="pw-emission-home w-full  flex flex-row grow">
      <div className="pw-creation-side-bar">
        <div
          className={`pw-org-side-elem ${
            activeSection === "basicInfo" ? "pw-org-active" : "pw-org-inactive"
          }`}
          onClick={() => {
            let element = document.getElementById("basicInfo");
            element?.scrollIntoView({ behavior: "smooth", block: "start" });
          }}
        >
          {t("Basic Info")}
        </div>
        <div
          className={`pw-org-side-elem ${
            activeSection === "assetMapping"
              ? "pw-org-active"
              : "pw-org-inactive"
          }`}
          onClick={() => {
            let element = document.getElementById("assetMapping");
            element?.scrollIntoView({ behavior: "smooth", block: "center" });
          }}
        >
          {t("Asset Mapping")}
        </div>
        <div
          className={`pw-org-side-elem ${
            activeSection === "additionalInfo"
              ? "pw-org-active"
              : "pw-org-inactive"
          }`}
          onClick={() => {
            let element = document.getElementById("additionalInfo");
            element?.scrollIntoView({ behavior: "smooth", block: "center" });
          }}
        >
          {t("Additional Info")}
        </div>
      </div>
      <div className="overflow-y-auto pw-emission-home-main">
        <div
          className="h-full"
          style={{ display: step === STEPS.BASIC_INFO ? "block" : "none" }}
        >
          <AssetCreation
            setStep={setStep}
            dispatch={dispatch}
            targetState={targetState}
            setIsSubmit={setIsSubmit}
            setActiveSection={setActiveSection}
            categoryPreferences={state?.categoryPreferences}
            scope={state?.scope}
            categoryData={state?.categoryData}
          />
        </div>
      </div>
    </div>
  );
};

export default TargetHome;
